import { Music2, Pause, Play, SkipForward } from 'lucide-react';

interface NowPlayingCardProps {
  data: {
    title?: string;
    artist?: string;
    album?: string;
    artwork_url?: string;
    is_playing?: boolean;
    progress?: number;       // 0-1
    duration_seconds?: number;
  };
}

export default function NowPlayingCard({ data }: NowPlayingCardProps) {
  const playing = data.is_playing !== false;
  return (
    <div
      className="my-2 border border-cyan-500/30 bg-[#0a1628]/80 backdrop-blur-sm p-3 max-w-[320px]"
      style={{
        clipPath:
          'polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 12px 100%, 0 calc(100% - 12px))',
      }}
    >
      <div className="flex items-center gap-3">
        {data.artwork_url ? (
          <img
            src={data.artwork_url}
            alt={data.album || 'album'}
            className="w-14 h-14 object-cover border border-cyan-500/20"
            referrerPolicy="no-referrer"
          />
        ) : (
          <div className="w-14 h-14 bg-black/40 border border-cyan-500/20 flex items-center justify-center">
            <Music2 className="w-6 h-6 text-cyan-400/60" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div className="text-sm text-white truncate">
            {data.title || 'Unknown title'}
          </div>
          <div className="text-xs text-cyan-300/80 truncate">
            {data.artist || ''}
            {data.album ? ` · ${data.album}` : ''}
          </div>
          <div className="mt-2 flex items-center gap-2 text-cyan-400">
            {playing ? (
              <Play className="w-3 h-3" />
            ) : (
              <Pause className="w-3 h-3" />
            )}
            <span className="text-[10px] tracking-widest">
              {playing ? 'PLAYING' : 'PAUSED'}
            </span>
            <SkipForward className="w-3 h-3 text-cyan-400/60 ml-auto" />
          </div>
        </div>
      </div>
      {typeof data.progress === 'number' && data.progress >= 0 && (
        <div className="mt-3 h-0.5 bg-black/40">
          <div
            className="h-full bg-cyan-400"
            style={{ width: `${Math.min(100, Math.max(0, data.progress * 100))}%` }}
          />
        </div>
      )}
    </div>
  );
}
